import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { OfbizTexboxQBEField } from '../ofbiz-form-model';
import { LookupFieldService } from '../ofbiz-lookup-field/lookup-field.service';
import { map, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'ubs-ofbiz-textqbe-field',
  templateUrl: './ofbiz-textqbe-field.component.html',
  styleUrls: ['./ofbiz-textqbe-field.component.scss']
})
export class OfbizTextqbeFieldComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() formField: OfbizTexboxQBEField;
  // Name of the form field for which the lookup is done
  fieldName: string;
  endpoint: string;
  // Name of the Entity to be searched
  entityName: string;
  // Name of the remote form which will be used to return results
  fieldFormName: string;
  // String Fields that will be searched on the backend
  searchFields: string;
  // The result list to be shown as options in the autocomplete dropdown
  lookupOptionList: any[];
  // Text shown in input field as placeholder
  placeHolderText: string = "";

  conditionFields: any[] = [];

  lookupSelectedValueSubscription: Subscription;

  public readonly results$ = this.lookupFieldService.result.pipe(
    map(rows => {
      const transformedItems: any[] = [];
      if (rows !== undefined && rows != null) {
        rows.forEach((row: any[]) => {
          const transItem = {};
          const idItem = row[0];
          transItem["id"] = (Object.values(idItem))[0];
          const descItem1 = row[1];
          const descItem2 = row[2];
          transItem["description"] = (Object.values(descItem1))[0] || (Object.values(descItem2))[0];
          transformedItems.push(transItem);
        });
        console.log({ TrackItems: transformedItems });
        this.lookupOptionList = transformedItems;
      }
      /* if(this.autoComplete.isClosed){
        this.autoComplete.show();
      } */
      return transformedItems;
    }

    )
  );

  /**
    * 1. Emits the value of the field to the OfbizFormFieldComponent
    * 2. The OfbizFormFieldComponent patches the form control with the received value
    */
  @Output() setLookupField: EventEmitter<any> = new EventEmitter<any>();
  @Output() openLookupDialogEvent: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('input', { static: true }) input: ElementRef;

  private readonly destroy$ = new Subject<void>();

  constructor(private lookupFieldService: LookupFieldService
  ) { }

  ngOnInit(): void {
    console.log("No implementation yet")
  }
  ngAfterViewInit(): void {
    if (this.formField) {
      // console.log({IsClosed:this.autoComplete.isClosed});
      console.log({ "lookupField": this.formField });
      this.entityName = this.formField.lookupOptions.entityName || '';
      this.searchFields = this.lookupFieldService.convertListToString(this.formField.lookupOptions.targetParameterList);
      this.fieldFormName = this.formField.lookupOptions.fieldFormName;
      this.fieldName = this.formField.name;
      this.conditionFields = this.formField.lookupOptions?.conditionFields || []
      const label = this.formField["label"] || this.fieldName;
      this.placeHolderText = "Enter text for " + label;
      console.log({ Placeholder: this.placeHolderText });
      // this.endpoint = this.formField["name"];
      if (this.formField.value) {
        // console.log({InitialValueLookup:"doing initial lookup"});
        // this.ofbizFormService.lookUp(this.formField.value,this.fieldName,this.entityName,this.searchFields,this.fieldFormName);
        this.lookupFieldService.doLookUp(this.formField.value, this.searchFields, this.entityName, this.fieldFormName, this.conditionFields)
          .subscribe(data => {
            this.input.nativeElement.value = data ? data[0]["description"] : "";
          })
      }

    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * @comment 1. Calls lookUp function in OfbizFormService
   * 2. Lookup function calls the lookUpSearch function
   * 3. LookUpSearch sets the the lookUpSearchFields,lookUpEntity,and lookUpFormName parameters
   * 4. LookUpSearch function also sets lookUpQuerySubject with the value of the query
   * @param query used to search backend
   */
  lookUp(query): void {
    console.log({ DoWeGetHere: "lookUp" });
    if (query !== "" && query.length > 3) {
      console.log(query, this.conditionFields);
      this.lookupFieldService.lookUp(query, this.fieldName, this.entityName, this.searchFields, this.fieldFormName, this.conditionFields);
    }

  }
  selectLookUp(e) {
    console.log({ SelectLookUp: e, lookupOptionList: this.lookupOptionList });
    let valueToEmit;
    const selectedDisplayOption = this.lookupOptionList.find(option => option.id == e);
    if (selectedDisplayOption) {
      this.input.nativeElement.value = selectedDisplayOption.description;
      valueToEmit = { value: e, description: selectedDisplayOption.description };
    } else {
      valueToEmit = e;
    }
    this.setLookupField.emit(valueToEmit);
    this.lookupFieldService.isSelected();
  }
}
